import { z } from 'zod';
import { isoDateSchema, mobileSchema, timezoneSchema } from './common.js';
import { userResponseSchema } from './user.js';
/**
 * Every way of signing in returns this identical envelope — password today, OTP from
 * Week 4 — so the client's session handling never changes when DLT clears.
 */
export const sessionResponseSchema = z.object({
    accessToken: z.string(),
    accessTokenExpiresAt: isoDateSchema,
    /** Opaque 32-byte token. Stored hashed server-side; kept in expo-secure-store on device. */
    refreshToken: z.string(),
    refreshTokenExpiresAt: isoDateSchema,
    user: userResponseSchema,
    /** True only on the request that created the account. Drives Onboarding vs Home. */
    isNewUser: z.boolean(),
});
/* ── OTP (the real path, from Week 4) ───────────────────────── */
export const requestOtpBodySchema = z.object({
    mobile: mobileSchema,
});
export const requestOtpResponseSchema = z.object({
    /** Binds the code to this attempt; verify will not accept a code without it. */
    requestId: z.string(),
    expiresAt: isoDateSchema,
    resendAfterSec: z.number().int(),
    /**
     * How the code was produced. `predictable` means it is the last six digits of the user's
     * own number and no SMS was sent — the app shows that as a hint on the code screen.
     */
    mode: z.enum(['predictable', 'sms']),
    /** Non-production only — the code itself, for automated tests. */
    devCode: z.string().optional(),
});
export const verifyOtpBodySchema = z.object({
    mobile: mobileSchema,
    requestId: z.string().min(1),
    code: z.string().regex(/^\d{6}$/, 'Enter the 6-digit code'),
    /** Sent on first verify so streaks run on the right calendar day from day one. */
    timezone: timezoneSchema.default('Asia/Kolkata'),
});
/* ── session lifecycle ──────────────────────────────────────── */
export const refreshBodySchema = z.object({
    refreshToken: z.string().min(1),
});
export const logoutBodySchema = z.object({
    refreshToken: z.string().min(1),
});
/* ── onboarding result ──────────────────────────────────────── */
/**
 * What onboarding gives back: the saved profile, and nothing else.
 *
 * It used to carry a matched journey, because onboarding ended on a preview of it. It no
 * longer does — changed 2026-09-30: the user lands on Home and chooses for themselves.
 * Home still recommends, through the same matcher, once it knows nothing is active.
 */
export const onboardingResponseSchema = z.object({
    user: userResponseSchema,
});
//# sourceMappingURL=auth.js.map